import videojs from 'video.js';
import { OffsettersData } from '../../data';
import { IComponentOptionsExtended } from '../../interfaces/component-options-extended.interface';
import { JumpButtonComponent } from '../jump-button.component.ts/jump-button.component';

class JumpBackComponent extends JumpButtonComponent {
  constructor(player: videojs.Player, options: IComponentOptionsExtended) {
    super(player, {
      ...options,
      classNames: 'vjs-jump-back',
    });

    this.controlText('Skip Backward');

    this.setAttribute('data-testid', 'htc-vp-jump-back-button');

    player.on('timeupdate', () => {
      this.handleEnableState();
    });
  }

  handleClick(): void {
    this.videoService.jumpStep(OffsettersData.jumpBackward);
  }

  handleEnableState(): void {
    this.videoService.setJumpBtnEnable(this, OffsettersData.jumpBackward);
  }
}

videojs.registerComponent('jumpBack', JumpBackComponent);
export default JumpBackComponent;
